import { render, staticRenderFns } from "./customertest.vue?vue&type=template&id=7119aa43"
import script from "./customertest.vue?vue&type=script&lang=js"
export * from "./customertest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports